
import {hasKey,isNullOrEmpty} from '@/utils/index'
import {mapGetters} from 'vuex'


export const mixins= {
    methods: {
        hasIcon: (item) => {
            return hasKey(item, 'icon');
        },
        hasChildren: (item) => {
            return !isNullOrEmpty(item.children);
        },
    },
    computed: {
        ...mapGetters('app/', ['menus', 'shrink']),
        theme: ()=>option.theme,
        color: ()=>option[`color_${option.theme}`],
    }
}